import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { api } from "./api";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import GameDetail from "./pages/GameDetail";
import Library from "./pages/Library";
import WishlistPage from "./pages/WishlistPage";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import DeveloperSubmit from "./pages/DeveloperSubmit";
import AdminDashboard from "./pages/AdminDashboard";
import DeveloperDashboard from "./pages/DeveloperDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AiAssistant from "./components/AiAssistant";
import "./App.css";

function AppRoutes() {
  const { user } = useAuth();
  const [purchasedCount, setPurchasedCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);

  const refreshCounts = useCallback(async () => {
    if (!user) {
      setPurchasedCount(0);
      setWishlistCount(0);
      return;
    }
    try {
      const [lib, wl] = await Promise.all([api.get("/library"), api.get("/wishlist")]);
      setPurchasedCount(lib.length);
      setWishlistCount(wl.length);
    } catch (e) {
      // ignore
    }
  }, [user]);

  useEffect(() => {
    refreshCounts();
  }, [refreshCounts]);

  return (
    <BrowserRouter>
      <Navbar purchasedCount={purchasedCount} wishlistCount={wishlistCount} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/game/:id"
            element={<GameDetail onAction={refreshCounts} />}
          />
          <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
          <Route path="/wishlist" element={<ProtectedRoute><WishlistPage onAction={refreshCounts} /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/developer/submit" element={<ProtectedRoute requiredRole="developer"><DeveloperSubmit /></ProtectedRoute>} />
          <Route path="/developer/dashboard" element={<ProtectedRoute requiredRole="developer"><DeveloperDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      <AiAssistant />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
